module.exports = __webpack_public_path__ + "static/media/32-12.ebebffbc.mp3";